
/*
 *   File : explore-filter.js
 *   Author : https://evoqins.com
 *   Description : UI element which is used to do the fund filter.
 *   Integrations : null
 *   Version : 1.0.0
*/
/* import packages */
import { useState, useRef, Fragment } from "react";

/* import components */
import { CheckBoxGroup } from "../FormElements";
import Icon from "../Icon/icon"
import { GradientButton, OutlineButton } from "../Cta";

const FILTER_DATA = [
    {
        type: "Order type",
        filter_id: 1,
        data: [
            {
                label: "All",
                id: null
            },
            {
                label: "Mandate",
                id: 1
            },
            {
                label: "Normal orders",
                id: 2
            },
        ]
    },
    {
        type: "Status",
        filter_id: 2,
        data: [
            {
                label: "All",
                id: null
            },
            {
                label: "Link created",
                id: 1
            },
            {
                label: "Payment success",
                id: 2
            },
            {
                label: "Order processing",
                id: 3
            },
            {
                label: "Allocation completed",
                id: 4
            },
            {
                label: "Allocation partially completed",
                id: 5
            },
            {
                label: "Order failed",
                id: 6
            },
        ]
    },
]


const OrderFilterPopup = (props) => {

    // state variables to store data
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState([]);


    // clearing all filter
    const _handleClear = () => {
        props.close()
    }

    const _handleFilterData = (checkbox_item, index) => {
        let selected_filter = []
        if (index === 0) {
            selected_filter = [...selectedOrder];
        } else if (index === 1) {
            selected_filter = [...selectedStatus]
        }
        const filter_index = selected_filter.findIndex((item) => item === checkbox_item.id);
        if (filter_index === -1) {
            selected_filter.push(checkbox_item.id);
            if (selected_filter.length === FILTER_DATA[index].data.length - 1) {
                selected_filter.push(null);
            }
        } else {
            selected_filter.splice(filter_index, 1);
            selected_filter = selected_filter.filter(item => item !== null);
        }
        if (checkbox_item.id !== null) {
            if (index === 0) {
                setSelectedOrder(selected_filter);

            } else if (index === 1) {
                setSelectedStatus(selected_filter);
            }
        } else {
            if (index === 0) {
                if (selectedOrder.length < FILTER_DATA[index].data.length) {
                    selected_filter = selected_filter.filter((item) => item !== checkbox_item.id)
                    FILTER_DATA[index].data.forEach((element) => {
                        selected_filter.push(element.id)
                    });

                } else {
                    selected_filter = []
                }
                setSelectedOrder(selected_filter);
            } else if (index === 1) {
                if (selectedStatus.length < FILTER_DATA[index].data.length) {
                    selected_filter = selected_filter.filter((item) => item !== checkbox_item.id)
                    FILTER_DATA[index].data.forEach((element) => {
                        selected_filter.push(element.id)
                    });

                } else {
                    selected_filter = []
                }
                setSelectedStatus(selected_filter);
            }
        }
    };


    return (

        <div className="border-radius-16px z-index-9 border-all border-bright-gray box-shadow-filter padding-24px-all bg-white position-absolute right-0 top-8px w-max-content">

            <div className="position-relative e-filter-popup-height">
                <Icon icon="close"
                    size={24}
                    className="position-absolute e-close top-0 end-0 cursor-pointer e-modal-close-btn"
                    onClick={_handleClear} />
                <div className="container-fluid">
                    <div className="row">

                        <Fragment>
                            <div className="bg-transparent">

                                {/* Fund category data */}
                                {
                                    FILTER_DATA.map((item, index) => {

                                        return (
                                            <div className={index !== FILTER_DATA.length - 1 ? "border-bottom-1px border-bright-gray pb-3" : ""}>
                                                <p className="color-charleston-green e-poppins-semi-bold e-font-14 line-height-24px mb-2">{item.type}</p>
                                                <div className="d-flex flex-column gap-12px   e-fund-category">

                                                    {
                                                        item.data.map((checkboxItem) => {

                                                            return (
                                                                <CheckBoxGroup
                                                                    sub_filter_id={checkboxItem.id}
                                                                    filter_id={item.filter_id}
                                                                    item={checkboxItem.label}
                                                                    selectedType={index === 0 ? selectedOrder : selectedStatus}
                                                                    onHandleClick={() => {
                                                                        _handleFilterData(checkboxItem, index)
                                                                    }} />
                                                            )
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        )
                                    })
                                }


                            </div>
                        </Fragment>

                    </div>
                </div>
            </div>

            {/* CTA buttons */}
            <div className="d-flex gap-16px justify-content-end  mt-3 pt-3 border-top-1px border-bright-gray">
                <GradientButton label="Apply filters"
                    className="e-font-16 padding-12px-tb px-3"
                    onPress={_handleClear} />
                <OutlineButton label="Clear filters"
                    className="e-font-16"
                    onPress={_handleClear} />
            </div>

        </div>

    )
}

export default OrderFilterPopup